const Style = {
    container: 'rounded-xl border border-border bg-surface shadow-sm',
    header: 'border-b border-border px-3.5 py-2.5',
    title: 'text-xs font-semibold uppercase tracking-wide text-text-secondary',
    body: 'px-3.5 py-3',
    row: 'flex items-center gap-3',
    name: 'truncate text-sm font-medium text-text-primary',
    email: 'truncate text-xs text-text-muted hover:text-primary-600 hover:underline',
};

export default Style;
